import { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import api from "../lib/api";

export const DemoRequestsTable = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    api.get("/admin/demo-requests").then((res) => setRequests(res.data));
  }, []);

  if (requests.length === 0) return null;

  return (
    <section className="fade-in-up">
      <h2 className="flex items-center gap-2 text-lg font-heading font-semibold mb-4">
        <Inbox className="w-5 h-5 text-[#C07A60]" strokeWidth={1.5} /> Demo requests
        <span className="bg-[#C07A60] text-white text-xs font-bold rounded-full px-2 py-0.5">{requests.length}</span>
      </h2>
      <div data-testid="demo-requests-table" className="bg-white border border-[#E8E6E1] rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E8E6E1] bg-[#F9F7F4]">
              <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Name</th>
              <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Email</th>
              <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A] hidden md:table-cell">Organization</th>
              <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A] hidden lg:table-cell">Message</th>
              <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Received</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.id} data-testid={`demo-request-row-${r.id}`} className="border-b border-[#E8E6E1] last:border-0 hover:bg-[#F9F7F4]/60 transition-colors duration-150">
                <td className="px-5 py-3 font-medium text-[#1C211F]">{r.name}</td>
                <td className="px-5 py-3 text-[#2E5C50]">{r.email}</td>
                <td className="px-5 py-3 text-[#57605A] hidden md:table-cell">{r.organization || "—"}</td>
                <td className="px-5 py-3 text-[#57605A] hidden lg:table-cell max-w-xs truncate">{r.message || "—"}</td>
                <td className="px-5 py-3 text-[#57605A] whitespace-nowrap">{new Date(r.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
